<template>
  <div :class="['hero_wrapper', { full: isVisibleResultInfo }]">
    <div class="hero_content">
      <div class="hero_search">
        <Text
          v-if="!isVisibleResultInfo"
          pattern="h2"
          :height="130"
          align="center"
          class="hero_title"
          :class="{
            hero_title_error: isError,
          }"
        >
          <div
            class="hero_title-text"
            v-html="$t(`SearchTitle${isError ? 'Error' : ''}`)"
          />
        </Text>
        <template v-if="!isVisibleResultInfo">
          <StatusFail
            class="hero_fail"
            v-if="isError"
            :text="$t('SearchSubtitleError')"
          />
        </template>
        <Text
          v-if="!isVisibleResultInfo"
          class="hero_footer"
          pattern="body1"
          color="#7a7a7a"
          :height="130"
          weight="400"
        >
          {{ $t("SearchFooter") }}
        </Text>
        <SearchInput
          v-model="internalSearchValue"
          :placeholder="$t('SearchPlaceholder')"
          @search="search"
          @clear="clear"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Text, SearchInput } from "@/shared/ui";
import StatusFail from "@/shared/ui/StatusFail/ui/StatusFail.vue";
export default {
  name: "HeroSection",
  components: { StatusFail, Text, SearchInput },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    resultsNumber: {
      type: Number,
      default: 0,
    },
    resultsQuery: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "search"],
  computed: {
    internalSearchValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    isVisibleResultInfo() {
      return !this.isError && !!this.resultsQuery && !!this.resultsNumber;
    },
  },
  methods: {
    search() {
      this.$emit("search", this.internalSearchValue);
    },
    clear() {
      this.internalSearchValue = "";
      this.$emit("clear");
    },
  },
};
</script>

<style lang="scss" scoped>
.hero {
  &_wrapper {
    display: flex;
    justify-content: center;
    align-items: baseline;
    flex-direction: column;
    height: 100%;
    width: 100%;
    min-height: calc(100vh - 800px);
    position: relative;

    &.full {
      padding-top: 20px;
      padding-bottom: 40px;
      margin-bottom: 40px;
      border-bottom: 1px solid #181818;
      min-height: 0;

      .hero_search {
        max-width: 100%;
      }
    }
  }

  &_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  &_search {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 764px;
  }

  &_results {
    margin-bottom: 14px;
  }

  &_title {
    &_error {
      margin-bottom: 59px;
    }

    &-text {
      word-break: break-word;
    }
  }

  &_subtitle {
    margin-bottom: 33px;

    &_error {
      margin-bottom: 15px;
    }
  }

  &_fail {
    margin-bottom: 15px;
  }

  &_footer {
    margin-top: 16px;
    margin-bottom: 60px;
    width: 100%;
    word-break: break-word !important;
    text-align: center !important;

    @media (max-width: 575px) {
      width: 240px;
      margin-top: 20px;
      margin-bottom: 48px;
    }
  }
}
</style>
